const TOP20_SPOTS = [
  {
    pos: 1,
    idVersion: 510438427,
    nombre: 'MEDIDAS CONTRA EL DENGUE',
    duracion: 55,
    veces: 5896,
    marca: 'AZTECA HONDURAS',
    canales: 'AZTECA HONDURAS',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50426025002050000-2317-2372.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/510438427.jpg',
  },
  {
    pos: 2,
    idVersion: 614759081,
    nombre: 'DESDE EL CORAZON DE NUESTRA TIERRA',
    duracion: 30,
    veces: 5449,
    marca: 'HARINA DE MAIZ SELECTA',
    canales: 'CANAL 10, TDTV, TELECADENA 7Y4',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/10/504/50401025278090000-1478-1508.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/614759081.jpg',
  },
  {
    pos: 3,
    idVersion: 534682429,
    nombre: 'QUEREMOS ESTAR CERCA TUYO',
    duracion: 30,
    veces: 3979,
    marca: 'FARMA FACIL',
    canales: 'AZTECA HONDURAS, CANAL 11, CANAL 5, HCH, HONDURED, QHUBO, QHUBOTV, TELECADENA 7Y4, TELESISTEMA 3Y7',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50438725001120000-2269-2299.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/534682429.jpg',
  },
  {
    pos: 4,
    idVersion: 616133271,
    nombre: 'HACE MAS DE 20 ANIOS MAS JUEGA DOBLE',
    duracion: 30,
    veces: 3385,
    marca: 'BETCCRIS.COM',
    canales: 'CANAL 11, CANAL 5, DEPORTES TVC, DTV, HCH, MEGA TV, TDTV, TELECADENA 7Y4, TELESISTEMA 3Y7, TIGO_SPORTS',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/10/504/50400925280170000-1763-1793.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/616133271.jpg',
  },
  {
    pos: 5,
    idVersion: 614946203,
    nombre: 'MOMENTOS REFRESCANTES',
    duracion: 30,
    veces: 3111,
    marca: 'ESPRESSO AMERICANO',
    canales: 'CANAL 10, CANAL 11, DTV, TDTV, TELESISTEMA 3Y7',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/10/504/50401125278080000-1452-1482.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/614946203.jpg',
  },
  {
    pos: 6,
    idVersion: 612040190,
    nombre: 'LOS LOPEZ',
    duracion: 30,
    veces: 3091,
    marca: 'CABLE COLOR',
    canales: 'CANAL 11, DISCOVERY, DTV, TDTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/4/504/50401125118120000-2399-2429.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/612040190.jpg',
  },
  {
    pos: 7,
    idVersion: 521929161,
    nombre: 'HONDURAS ES',
    duracion: 30,
    veces: 3079,
    marca: 'HONDUBET',
    canales: 'AZTECA HONDURAS, CANAL 11, CANAL 5, DEPORTES TVC, DTV, GO TV, HCH, MEGA TV, TDTV, TELECADENA 7Y4, TELESISTEMA 3Y7, TIGO_SPORTS',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50480925018140000-1015-1045.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/521929161.jpg',
  },
  {
    pos: 8,
    idVersion: 621336984,
    nombre: '2 ANIO CONSECUTIVO GANANDO COMO LA RED MAS RAPIDA DE HONDURAS',
    duracion: 30,
    veces: 2928,
    marca: 'CABLE COLOR',
    canales: 'AXN, CANAL 11, CANAL 5, DISCOVERY, DTV, HCH, QHUBO, QHUBOTV, TDTV, TELECADENA 7Y4, TELESISTEMA 3Y7',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/10/504/50401125277160000-668-698.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/621336984.jpg',
  },
  {
    pos: 9,
    idVersion: 511835420,
    nombre: 'LA DONA DE LAS HARINAS',
    duracion: 30,
    veces: 2913,
    marca: 'HARINA DOÑA BLANCA',
    canales: 'CANAL 10, HCH, TDTV, TELECADENA 7Y4',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50401025006180000-1491-1521.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/511835420.jpg',
  },
  {
    pos: 10,
    idVersion: 604843445,
    nombre: 'TU SEGURIDAD ES NUESTRA PRIORIDAD',
    duracion: 30,
    veces: 2838,
    marca: 'CONATEL',
    canales: 'AXN, CANAL 11, CANAL 5, DISCOVERY, DTV, HCH, HISTORY, HONDURED, TELECADENA 7Y4, TELESISTEMA 3Y7, TIGO_SPORTS, VTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/2/504/50400925052070000-1752-1782.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/604843445.jpg',
  },
  {
    pos: 11,
    idVersion: 609253452,
    nombre: 'CALLE 7 VIVI TODO EN PRIMERA FILA PATROCINADORES',
    duracion: 35,
    veces: 2730,
    marca: 'CANAL 11',
    canales: 'CANAL 11, DTV, TDTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/4/504/50401125092060000-723-758.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/609253452.jpg',
  },
  {
    pos: 12,
    idVersion: 612038848,
    nombre: 'LOS LOPEZ',
    duracion: 30,
    veces: 2594,
    marca: 'CABLE COLOR',
    canales: 'AXN, CANAL 11, DISCOVERY, DTV, TDTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/4/504/50422225118130000-1513-1543.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/612038848.jpg',
  },
  {
    pos: 13,
    idVersion: 622753163,
    nombre: 'SUPER RECARGA TIGO 7 DIAS Y DISFRUTA MAS DIAS',
    duracion: 30,
    veces: 2530,
    marca: 'TIGO ',
    canales: '12TV, AZTECA HONDURAS, CANAL 10, CANAL 11, CANAL 5, DEPORTES TVC, DTV, GO TV, HCH, MEGA TV, QHUBO, QHUBOTV, TDTV, TELECADENA 7Y4, TELESISTEMA 3Y7, TIGO_SPORTS, VTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/10/504/50400925279170000-1811-1841.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/622753163.jpg',
  },
  {
    pos: 14,
    idVersion: 621431323,
    nombre: 'FULL CLARO FULL BENEFICIOS',
    duracion: 30,
    veces: 2523,
    marca: 'CLARO ',
    canales: 'AZTECA HONDURAS, CANAL 10, CANAL 11, CANAL 5, CANAL 6, DEPORTES TVC, HCH, HONDURED, MEGA TV, QHUBO, QHUBOTV, TELECADENA 7Y4, TELESISTEMA 3Y7, VTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/10/504/50406225287170000-1417-1447.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/621431323.jpg',
  },
  {
    pos: 15,
    idVersion: 600770263,
    nombre: 'NUEVA TIENDA ONLINE',
    duracion: 45,
    veces: 2515,
    marca: 'ESPRESSO AMERICANO',
    canales: 'CANAL 11, DTV, TDTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50401125005080000-1459-1504.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/600770263.jpg',
  },
  {
    pos: 16,
    idVersion: 602153222,
    nombre: 'VIVE EL DEPORTE AL LIMITE',
    duracion: 30,
    veces: 2474,
    marca: 'LOTO',
    canales: 'CANAL 5, DEPORTES TVC, HCH, MEGA TV, QHUBOTV, TELECADENA 7Y4, TELESISTEMA 3Y7, TIGO_SPORTS',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50400925026110000-1780-1810.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/602153222.jpg',
  },
  {
    pos: 17,
    idVersion: 602357674,
    nombre: 'OOKLA NOS HA PREMIADO COMO LA RED MAS RAPIDA DE HONDURAS',
    duracion: 30,
    veces: 2440,
    marca: 'CABLE COLOR',
    canales: 'AXN, CANAL 11, CANAL 5, DISCOVERY, DTV, HCH, TDTV, TELECADENA 7Y4, TELESISTEMA 3Y7',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50400925024210000-3501-3531.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/602357674.jpg',
  },
  {
    pos: 18,
    idVersion: 525757725,
    nombre: 'TE PRESENTAMOS NUESTRAS NOVEDOSAS EDICIONES DIGITALES',
    duracion: 25,
    veces: 2388,
    marca: 'REVISTA CROMOS',
    canales: 'CANAL 10',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/1/504/50406125003130000-3117-3142.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/525757725.jpg',
  },
  {
    pos: 19,
    idVersion: 615446949,
    nombre: 'CLARO OFERTAS CELULARES PREPAGO',
    duracion: 30,
    veces: 2338,
    marca: 'CLARO ',
    canales: 'AZTECA HONDURAS, CANAL 10, CANAL 11, CANAL 5, DEPORTES TVC, HCH, HONDURED, MEGA TV, QHUBO, QHUBOTV, TELECADENA 7Y4, TELESISTEMA 3Y7, VTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/6/504/50400925158090000-1249-1279.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/615446949.jpg',
  },
  {
    pos: 20,
    idVersion: 608739725,
    nombre: 'MEJOR SENAL MAYOR COBERTURA 30SEG',
    duracion: 30,
    veces: 2308,
    marca: 'TIGO ',
    canales: 'AZTECA HONDURAS, CANAL 10, CANAL 11, DTV, GO TV, HCH, QHUBO, QHUBOTV, TDTV, TELECADENA 7Y4, TELESISTEMA 3Y7, TIGO_SPORTS, VTV',
    testigo: 'https://s3.us-east-2.wasabisys.com/testigos/videos-cortados/2025/3/504/50401025085180000-2243-2273.mp4',
    thumbnail: 'https://s3.wasabisys.com/sarv27/version-thumbnail/504/608739725.jpg',
  },
];

export default TOP20_SPOTS;
